var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1919,
    height: 1134,
    viewBox: "0 0 1919 1134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4841_17758)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1919,
    height: 1133.06,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.648 549.512L787.376 545.77L798.602 529.306V518.081L809.827 511.345L824.795 500.868L840.51 507.604L863.71 493.385L879.425 491.14L897.386 493.385L913.101 486.649L919.837 500.868L913.101 507.604L930.314 518.081H940.043L951.268 529.306L966.235 534.545L973.719 529.306V518.081H990.183L1009.64 529.306H1029.1H1047.06L1056.79 549.512L1061.28 560.737L1069.51 576.453L1075.5 591.42V603.394L1085.97 612.374L1091.96 630.335L1103.93 638.567L1114.41 651.289L1118.9 663.263L1127.13 668.502L1140.6 671.495L1166.05 663.263V681.972L1154.82 700.681L1144.35 717.145L1130.13 730.616L1114.41 748.577L1100.94 763.544L1091.96 780.008L1096.45 800.214L1103.93 809.942V826.406V841.374L1096.45 854.096L1082.23 857.838L1075.5 867.566L1065.77 878.792L1069.51 897.501L1065.77 905.733L1055.29 913.216L1050.05 919.952V927.435L1047.81 936.416L1029.85 958.118L1013.38 969.344L999.163 976.079L991.68 969.344L981.951 976.079H969.229L963.99 969.344V958.118L958.003 944.648L946.029 930.429V919.952L941.539 897.501L934.804 878.792L925.075 863.824V850.354L930.314 837.632L934.804 822.664V809.942V800.214L930.314 788.988L925.075 772.524L919.837 766.537L913.101 756.06V744.086V726.126V717.145L902.624 708.913H888.405L882.419 700.681L872.69 695.443L859.968 700.681L844.252 705.171H824.795L805.337 708.913L792.615 705.171L773.906 690.204L768.667 681.972L761.932 671.495L755.945 663.263L752.203 658.025V648.296L746.965 640.812L752.203 631.832V616.116V608.633V599.652V589.175L761.932 576.453L768.667 560.737L777.648 549.512Z",
    stroke: "#FFC700",
    strokeWidth: 3,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4841_17758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M777.648 549.512L787.376 545.77L798.602 529.306V518.081L809.827 511.345L824.795 500.868L840.51 507.604L863.71 493.385L879.425 491.14L897.386 493.385L913.101 486.649L919.837 500.868L913.101 507.604L930.314 518.081H940.043L951.268 529.306L966.235 534.545L973.719 529.306V518.081H990.183L1009.64 529.306H1029.1H1047.06L1056.79 549.512L1061.28 560.737L1069.51 576.453L1075.5 591.42V603.394L1085.97 612.374L1091.96 630.335L1103.93 638.567L1114.41 651.289L1118.9 663.263L1127.13 668.502L1140.6 671.495L1166.05 663.263V681.972L1154.82 700.681L1144.35 717.145L1130.13 730.616L1114.41 748.577L1100.94 763.544L1091.96 780.008L1096.45 800.214L1103.93 809.942V826.406V841.374L1096.45 854.096L1082.23 857.838L1075.5 867.566L1065.77 878.792L1069.51 897.501L1065.77 905.733L1055.29 913.216L1050.05 919.952V927.435L1047.81 936.416L1029.85 958.118L1013.38 969.344L999.163 976.079L991.68 969.344L981.951 976.079H969.229L963.99 969.344V958.118L958.003 944.648L946.029 930.429V919.952L941.539 897.501L934.804 878.792L925.075 863.824V850.354L930.314 837.632L934.804 822.664V809.942V800.214L930.314 788.988L925.075 772.524L919.837 766.537L913.101 756.06V744.086V726.126V717.145L902.624 708.913H888.405L882.419 700.681L872.69 695.443L859.968 700.681L844.252 705.171H824.795L805.337 708.913L792.615 705.171L773.906 690.204L768.667 681.972L761.932 671.495L755.945 663.263L752.203 658.025V648.296L746.965 640.812L752.203 631.832V616.116V608.633V599.652V589.175L761.932 576.453L768.667 560.737L777.648 549.512Z",
    stroke: "#FFEC3F",
    strokeOpacity: 0.9,
    strokeWidth: 3,
    strokeDasharray: "2 2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1151.83 831.645L1137.61 847.36L1123.39 855.592V875.05L1116.66 889.269V904.236L1123.39 912.468H1137.61L1145.84 904.236V889.269L1155.57 865.321L1160.06 847.36V831.645L1155.57 824.161L1151.83 831.645Z",
    stroke: "#FFC700",
    strokeWidth: 3,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_4841_17758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1151.83 831.645L1137.61 847.36L1123.39 855.592V875.05L1116.66 889.269V904.236L1123.39 912.468H1137.61L1145.84 904.236V889.269L1155.57 865.321L1160.06 847.36V831.645L1155.57 824.161L1151.83 831.645Z",
    stroke: "#FFEC3F",
    strokeOpacity: 0.9,
    strokeWidth: 3,
    strokeDasharray: "2 2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1680.92 1032.21L1686.16 1019.48H1698.13L1704.12 1023.97L1698.13 1032.21L1686.16 1036.7L1680.92 1032.21Z",
    stroke: "#FFC700",
    strokeWidth: 3,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_4841_17758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1680.92 1032.21L1686.16 1019.48H1698.13L1704.12 1023.97L1698.13 1032.21L1686.16 1036.7L1680.92 1032.21Z",
    stroke: "#FFEC3F",
    strokeOpacity: 0.9,
    strokeWidth: 3,
    strokeDasharray: "2 2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1608.33 960.363L1589.62 968.595H1564.93L1554.45 974.582L1543.22 980.569L1537.98 974.582V968.595L1543.22 952.131V929.68V906.481L1550.71 893.011L1577.65 877.295H1589.62L1608.33 858.586L1613.57 851.851L1623.3 841.374L1639.01 836.135L1649.49 841.374L1654.73 833.89L1664.46 827.155L1682.42 821.916C1698.58 819.521 1697.14 826.406 1694.39 830.148L1686.16 841.374L1694.39 847.36L1713.85 858.586L1727.32 841.374V830.148L1735.55 818.174L1739.29 830.148L1749.02 841.374V861.579L1755.76 870.56L1766.98 893.011L1778.21 906.481V919.952L1772.22 944.648L1761 960.363L1749.02 968.595L1739.29 987.304L1727.32 997.033H1716.09L1710.86 1002.27L1703.37 1006.76L1694.39 1002.27H1682.42L1673.44 997.033V987.304L1669.7 980.569L1662.21 968.595L1654.73 974.582L1645.75 960.363L1636.02 956.621H1627.79L1608.33 960.363Z",
    stroke: "#FFC700",
    strokeWidth: 3,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_4841_17758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1608.33 960.363L1589.62 968.595H1564.93L1554.45 974.582L1543.22 980.569L1537.98 974.582V968.595L1543.22 952.131V929.68V906.481L1550.71 893.011L1577.65 877.295H1589.62L1608.33 858.586L1613.57 851.851L1623.3 841.374L1639.01 836.135L1649.49 841.374L1654.73 833.89L1664.46 827.155L1682.42 821.916C1698.58 819.521 1697.14 826.406 1694.39 830.148L1686.16 841.374L1694.39 847.36L1713.85 858.586L1727.32 841.374V830.148L1735.55 818.174L1739.29 830.148L1749.02 841.374V861.579L1755.76 870.56L1766.98 893.011L1778.21 906.481V919.952L1772.22 944.648L1761 960.363L1749.02 968.595L1739.29 987.304L1727.32 997.033H1716.09L1710.86 1002.27L1703.37 1006.76L1694.39 1002.27H1682.42L1673.44 997.033V987.304L1669.7 980.569L1662.21 968.595L1654.73 974.582L1645.75 960.363L1636.02 956.621H1627.79L1608.33 960.363Z",
    stroke: "#FFEC3F",
    strokeOpacity: 0.9,
    strokeWidth: 3,
    strokeDasharray: "2 2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1804.4 1056.9H1787.94C1787.94 1051.51 1793.92 1044.68 1796.92 1041.93L1815.63 1032.21L1832.09 1026.97L1846.31 1017.24V1026.97L1837.33 1032.21L1832.09 1041.93H1824.61L1815.63 1050.92L1804.4 1056.9Z",
    stroke: "#FFC700",
    strokeWidth: 3,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_4841_17758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1804.4 1056.9H1787.94C1787.94 1051.51 1793.92 1044.68 1796.92 1041.93L1815.63 1032.21L1832.09 1026.97L1846.31 1017.24V1026.97L1837.33 1032.21L1832.09 1041.93H1824.61L1815.63 1050.92L1804.4 1056.9Z",
    stroke: "#FFEC3F",
    strokeOpacity: 0.9,
    strokeWidth: 3,
    strokeDasharray: "2 2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1867.26 1022.48H1857.53L1861.28 1012V1003.77L1871.75 999.278L1876.24 983.562L1880.73 994.788L1887.47 1003.77L1876.24 1012L1867.26 1022.48Z",
    stroke: "#FFC700",
    strokeWidth: 3,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_4841_17758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1867.26 1022.48H1857.53L1861.28 1012V1003.77L1871.75 999.278L1876.24 983.562L1880.73 994.788L1887.47 1003.77L1876.24 1012L1867.26 1022.48Z",
    stroke: "#FFEC3F",
    strokeOpacity: 0.9,
    strokeWidth: 3,
    strokeDasharray: "2 2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M520.958 1109.29L500.752 1098.06H486.533L467.075 1089.83L457.347 1074.11L444.624 1056.15L449.863 1049.42V1039.69L444.624 1029.96L434.147 1016.49V1003.02L430.406 967.098L425.167 934.919V904.984V877.295L410.2 860.082L391.491 848.109L379.517 831.645L367.543 812.187L357.066 787.491L348.834 783.749V766.537L357.066 759.802L348.834 750.073L357.066 734.357L367.543 717.893L372.782 710.41V699.933L367.543 681.972V676.733L372.782 681.972L379.517 676.733L387.001 667.753H395.233L402.716 658.024H410.2L413.942 671.495L410.2 681.972L402.716 671.495L419.18 661.766H430.406L437.141 667.753L449.115 671.495L463.334 667.753L472.314 671.495L489.526 692.449L497.01 699.933H508.984L526.196 705.171L533.68 717.893L538.918 729.119V738.099L547.899 743.338L556.131 750.073H566.608L571.846 753.815L582.323 759.802H598.039L610.761 766.537L624.98 774.769L633.212 778.511V787.491V800.213L621.238 819.671L610.761 831.645V848.109V871.308L598.039 893.01L587.562 896.752L571.846 904.984L560.621 915.461V925.938L556.131 946.144L543.408 967.098L533.68 976.079H524.699H516.467L520.958 984.311V996.285L511.229 1003.02H500.752V1016.49H486.533V1024.72L492.52 1029.96L486.533 1043.43V1049.42V1056.15L492.52 1065.13V1074.11L486.533 1083.09L492.52 1089.83L486.533 1109.29H497.01L505.99 1113.03L520.958 1109.29Z",
    stroke: "#FFC700",
    strokeWidth: 3,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_4841_17758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M520.958 1109.29L500.752 1098.06H486.533L467.075 1089.83L457.347 1074.11L444.624 1056.15L449.863 1049.42V1039.69L444.624 1029.96L434.147 1016.49V1003.02L430.406 967.098L425.167 934.919V904.984V877.295L410.2 860.082L391.491 848.109L379.517 831.645L367.543 812.187L357.066 787.491L348.834 783.749V766.537L357.066 759.802L348.834 750.073L357.066 734.357L367.543 717.893L372.782 710.41V699.933L367.543 681.972V676.733L372.782 681.972L379.517 676.733L387.001 667.753H395.233L402.716 658.024H410.2L413.942 671.495L410.2 681.972L402.716 671.495L419.18 661.766H430.406L437.141 667.753L449.115 671.495L463.334 667.753L472.314 671.495L489.526 692.449L497.01 699.933H508.984L526.196 705.171L533.68 717.893L538.918 729.119V738.099L547.899 743.338L556.131 750.073H566.608L571.846 753.815L582.323 759.802H598.039L610.761 766.537L624.98 774.769L633.212 778.511V787.491V800.213L621.238 819.671L610.761 831.645V848.109V871.308L598.039 893.01L587.562 896.752L571.846 904.984L560.621 915.461V925.938L556.131 946.144L543.408 967.098L533.68 976.079H524.699H516.467L520.958 984.311V996.285L511.229 1003.02H500.752V1016.49H486.533V1024.72L492.52 1029.96L486.533 1043.43V1049.42V1056.15L492.52 1065.13V1074.11L486.533 1083.09L492.52 1089.83L486.533 1109.29H497.01L505.99 1113.03L520.958 1109.29Z",
    stroke: "#FFEC3F",
    strokeOpacity: 0.9,
    strokeWidth: 3,
    strokeDasharray: "2 2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1772.97 797.22L1789.43 812.936L1784.19 818.174L1772.97 812.936L1760.25 801.71L1752.76 797.22H1744.53L1739.29 805.452L1724.32 801.71L1716.09 797.22H1708.61L1716.09 785.994L1708.61 779.259L1687.65 771.027L1676.43 767.285V759.802L1668.95 747.08H1687.65V753.066L1695.89 767.285L1703.37 759.802L1716.09 753.066L1729.56 759.802L1752.76 767.285L1768.48 779.259L1772.97 797.22Z",
    stroke: "#FFC700",
    strokeWidth: 3,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_4841_17758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1772.97 797.22L1789.43 812.936L1784.19 818.174L1772.97 812.936L1760.25 801.71L1752.76 797.22H1744.53L1739.29 805.452L1724.32 801.71L1716.09 797.22H1708.61L1716.09 785.994L1708.61 779.259L1687.65 771.027L1676.43 767.285V759.802L1668.95 747.08H1687.65V753.066L1695.89 767.285L1703.37 759.802L1716.09 753.066L1729.56 759.802L1752.76 767.285L1768.48 779.259L1772.97 797.22Z",
    stroke: "#FFEC3F",
    strokeOpacity: 0.9,
    strokeWidth: 3,
    strokeDasharray: "2 2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1561.18 712.655L1546.21 723.88L1531.25 731.364L1534.24 748.576L1541.72 760.55L1561.18 768.033H1576.15V760.55L1587.37 744.834L1591.86 738.847V728.37L1587.37 719.39L1591.86 706.668L1587.37 699.184H1576.15L1561.18 712.655Z",
    stroke: "#FFC700",
    strokeWidth: 3,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_4841_17758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1561.18 712.655L1546.21 723.88L1531.25 731.364L1534.24 748.576L1541.72 760.55L1561.18 768.033H1576.15V760.55L1587.37 744.834L1591.86 738.847V728.37L1587.37 719.39L1591.86 706.668L1587.37 699.184H1576.15L1561.18 712.655Z",
    stroke: "#FFEC3F",
    strokeOpacity: 0.9,
    strokeWidth: 3,
    strokeDasharray: "2 2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1549.96 785.995L1566.42 795.723L1558.19 800.214L1541.73 795.723H1529.01H1514.04L1510.3 785.995H1523.02H1535.74H1549.96Z",
    stroke: "#FFC700",
    strokeWidth: 3,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_4841_17758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1549.96 785.995L1566.42 795.723L1558.19 800.214L1541.73 795.723H1529.01H1514.04L1510.3 785.995H1523.02H1535.74H1549.96Z",
    stroke: "#FFEC3F",
    strokeOpacity: 0.9,
    strokeWidth: 3,
    strokeDasharray: "2 2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1511.04 762.795V774.021C1511.04 783.001 1500.57 781.754 1495.33 780.008L1484.85 768.782L1475.12 747.828L1460.15 726.126L1447.43 714.152V703.675L1472.13 714.152L1479.61 726.126L1495.33 737.351V744.835L1511.04 762.795Z",
    stroke: "#FFC700",
    strokeWidth: 3,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_4841_17758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1511.04 762.795V774.021C1511.04 783.001 1500.57 781.754 1495.33 780.008L1484.85 768.782L1475.12 747.828L1460.15 726.126L1447.43 714.152V703.675L1472.13 714.152L1479.61 726.126L1495.33 737.351V744.835L1511.04 762.795Z",
    stroke: "#FFEC3F",
    strokeOpacity: 0.9,
    strokeWidth: 3,
    strokeDasharray: "2 2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1591.87 635.574L1595.61 620.606C1597.1 614.62 1601.72 618.112 1603.84 620.606V635.574L1612.07 642.309L1621.05 656.528L1633.77 671.495L1639.01 685.714V702.178H1628.54L1621.05 693.946L1612.07 675.237L1603.84 656.528L1591.87 635.574Z",
    stroke: "#FFC700",
    strokeWidth: 3,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_4841_17758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1591.87 635.574L1595.61 620.606C1597.1 614.62 1601.72 618.112 1603.84 620.606V635.574L1612.07 642.309L1621.05 656.528L1633.77 671.495L1639.01 685.714V702.178H1628.54L1621.05 693.946L1612.07 675.237L1603.84 656.528L1591.87 635.574Z",
    stroke: "#FFEC3F",
    strokeOpacity: 0.9,
    strokeWidth: 3,
    strokeDasharray: "2 2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1481.86 720.139L1475.12 699.933L1462.4 680.476V657.276L1471.38 666.257V675.985L1475.12 684.217L1481.86 692.449L1494.58 699.933L1499.82 712.655V730.616H1494.58L1481.86 720.139Z",
    stroke: "#FFC700"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_4841_17758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1481.86 720.139L1475.12 699.933L1462.4 680.476V657.276L1471.38 666.257V675.985L1475.12 684.217L1481.86 692.449L1494.58 699.933L1499.82 712.655V730.616H1494.58L1481.86 720.139Z",
    stroke: "#FFEC3F",
    strokeOpacity: 0.9
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1417.5 601.897L1410.76 589.175L1387.56 592.917L1382.32 607.884L1370.35 616.116L1347.9 637.07L1344.16 649.044V672.243C1342.36 686.612 1332.43 684.217 1327.69 681.224L1314.22 654.283L1297.76 616.116V597.407H1288.03H1277.55V585.433H1266.33L1253.6 567.473L1245.37 574.208L1224.42 567.473H1205.71L1194.48 558.492L1168.29 555.499L1156.32 541.28L1148.08 534.545L1142.85 541.28L1151.83 551.757L1156.32 567.473H1168.29L1176.52 577.95L1189.99 567.473L1197.48 574.208L1213.19 585.433V597.407L1201.22 616.116L1185.5 623.6L1168.29 633.328L1151.83 642.309L1139.1 654.283H1123.39L1115.9 642.309V628.838L1107.67 616.116L1093.45 601.897V589.175L1071 562.982L1064.27 545.022L1056.04 551.757L1047.06 527.061H1060.53L1064.27 509.1V492.636L1051.55 497.126L1035.08 492.636H1017.12L1007.39 473.179V466.443H998.412L989.431 473.179L993.922 483.656L989.431 492.636L978.954 487.398L982.696 479.914L969.974 473.179L964.735 453.721L951.265 445.489L931.807 432.019C923.426 424.236 925.82 432.767 928.066 438.006L937.794 449.231C945.527 454.969 959.796 466.443 955.007 466.443C950.217 466.443 950.516 477.918 951.265 483.656L937.794 466.443L916.84 449.231L906.363 441.747L887.654 449.231H877.177L870.442 461.205L854.726 473.179V487.398L836.017 492.636H818.805L805.334 483.656L810.573 449.231H841.255L847.991 441.747V426.032L836.017 412.561L854.726 408.82L870.442 399.839L891.396 383.375H899.628L906.363 376.64V362.421L914.595 355.686V365.414L924.324 362.421V351.944L916.84 346.705L906.363 351.944L895.138 346.705V327.248L928.066 302.552L951.265 285.34L969.974 274.863H1002.15L1021.61 285.34L1051.55 289.081C1061.12 296.864 1055.54 301.305 1051.55 302.552H1039.57L1021.61 296.565L1039.57 311.532H1051.55L1060.53 302.552L1071 296.565L1075.49 289.081L1088.22 296.565L1107.67 289.081H1133.12L1159.31 285.34H1175.77L1166.79 274.863L1170.54 267.379H1186.25L1196.73 274.863L1212.44 267.379L1224.42 259.895H1240.88V251.663L1265.58 245.676H1281.29L1289.52 239.689H1303.74L1317.96 245.676H1338.92L1344.16 251.663L1338.92 259.895L1366.61 263.637H1372.59H1386.06H1398.79H1422.73L1449.67 274.863H1465.39H1478.11L1481.85 263.637L1506.55 267.379L1535.74 274.863H1561.18H1578.39L1597.85 285.34H1634.52L1641.26 280.849H1659.22L1686.91 285.34L1711.6 292.823L1727.32 298.81H1744.53L1755.01 310.036H1733.3L1722.08 302.552L1711.6 310.036L1727.32 317.519V325.751L1711.6 336.977H1695.89C1680.32 341.167 1683.41 348.202 1686.91 351.196L1699.63 356.434L1703.37 375.892V396.097H1695.89L1676.43 375.892L1663.71 356.434L1669.69 331.738L1663.71 325.751L1654.73 331.738H1645H1634.52V344.46H1616.56H1589.62L1578.39 351.196L1570.91 369.156L1582.88 375.892H1594.86L1611.32 382.627H1620.3L1634.52 396.097L1645 406.574V414.806L1649.49 429.774L1641.26 425.284L1634.52 414.806L1624.04 399.839H1620.3L1624.04 414.806V429.774L1616.56 447.734H1604.59L1597.85 453.721L1594.86 462.702V469.437L1597.85 476.921L1611.32 486.649L1616.56 497.126L1611.32 505.358H1597.85L1594.86 491.888L1578.39 480.662L1570.91 469.437C1561.33 474.825 1557.94 471.682 1557.44 469.437L1548.46 462.702L1535.74 476.921L1548.46 486.649H1557.44L1570.91 491.888L1553.7 503.113L1570.91 518.829L1578.39 530.054L1582.88 545.77L1578.39 565.976L1570.91 580.943L1553.7 589.175L1535.74 592.917L1526.01 601.897L1516.28 592.917L1506.55 599.652L1502.06 611.626L1516.28 628.838L1526.01 645.302V664.011L1516.28 672.243L1509.54 681.224H1502.06V672.243L1489.34 664.011L1474.37 654.283H1469.13V664.011L1461.65 654.283L1455.66 637.07L1449.67 628.838L1442.19 633.328H1434.71V623.6L1429.47 611.626L1417.5 601.897Z",
    stroke: "#FFC700",
    strokeWidth: 3,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_4841_17758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1417.5 601.897L1410.76 589.175L1387.56 592.917L1382.32 607.884L1370.35 616.116L1347.9 637.07L1344.16 649.044V672.243C1342.36 686.612 1332.43 684.217 1327.69 681.224L1314.22 654.283L1297.76 616.116V597.407H1288.03H1277.55V585.433H1266.33L1253.6 567.473L1245.37 574.208L1224.42 567.473H1205.71L1194.48 558.492L1168.29 555.499L1156.32 541.28L1148.08 534.545L1142.85 541.28L1151.83 551.757L1156.32 567.473H1168.29L1176.52 577.95L1189.99 567.473L1197.48 574.208L1213.19 585.433V597.407L1201.22 616.116L1185.5 623.6L1168.29 633.328L1151.83 642.309L1139.1 654.283H1123.39L1115.9 642.309V628.838L1107.67 616.116L1093.45 601.897V589.175L1071 562.982L1064.27 545.022L1056.04 551.757L1047.06 527.061H1060.53L1064.27 509.1V492.636L1051.55 497.126L1035.08 492.636H1017.12L1007.39 473.179V466.443H998.412L989.431 473.179L993.922 483.656L989.431 492.636L978.954 487.398L982.696 479.914L969.974 473.179L964.735 453.721L951.265 445.489L931.807 432.019C923.426 424.236 925.82 432.767 928.066 438.006L937.794 449.231C945.527 454.969 959.796 466.443 955.007 466.443C950.217 466.443 950.516 477.918 951.265 483.656L937.794 466.443L916.84 449.231L906.363 441.747L887.654 449.231H877.177L870.442 461.205L854.726 473.179V487.398L836.017 492.636H818.805L805.334 483.656L810.573 449.231H841.255L847.991 441.747V426.032L836.017 412.561L854.726 408.82L870.442 399.839L891.396 383.375H899.628L906.363 376.64V362.421L914.595 355.686V365.414L924.324 362.421V351.944L916.84 346.705L906.363 351.944L895.138 346.705V327.248L928.066 302.552L951.265 285.34L969.974 274.863H1002.15L1021.61 285.34L1051.55 289.081C1061.12 296.864 1055.54 301.305 1051.55 302.552H1039.57L1021.61 296.565L1039.57 311.532H1051.55L1060.53 302.552L1071 296.565L1075.49 289.081L1088.22 296.565L1107.67 289.081H1133.12L1159.31 285.34H1175.77L1166.79 274.863L1170.54 267.379H1186.25L1196.73 274.863L1212.44 267.379L1224.42 259.895H1240.88V251.663L1265.58 245.676H1281.29L1289.52 239.689H1303.74L1317.96 245.676H1338.92L1344.16 251.663L1338.92 259.895L1366.61 263.637H1372.59H1386.06H1398.79H1422.73L1449.67 274.863H1465.39H1478.11L1481.85 263.637L1506.55 267.379L1535.74 274.863H1561.18H1578.39L1597.85 285.34H1634.52L1641.26 280.849H1659.22L1686.91 285.34L1711.6 292.823L1727.32 298.81H1744.53L1755.01 310.036H1733.3L1722.08 302.552L1711.6 310.036L1727.32 317.519V325.751L1711.6 336.977H1695.89C1680.32 341.167 1683.41 348.202 1686.91 351.196L1699.63 356.434L1703.37 375.892V396.097H1695.89L1676.43 375.892L1663.71 356.434L1669.69 331.738L1663.71 325.751L1654.73 331.738H1645H1634.52V344.46H1616.56H1589.62L1578.39 351.196L1570.91 369.156L1582.88 375.892H1594.86L1611.32 382.627H1620.3L1634.52 396.097L1645 406.574V414.806L1649.49 429.774L1641.26 425.284L1634.52 414.806L1624.04 399.839H1620.3L1624.04 414.806V429.774L1616.56 447.734H1604.59L1597.85 453.721L1594.86 462.702V469.437L1597.85 476.921L1611.32 486.649L1616.56 497.126L1611.32 505.358H1597.85L1594.86 491.888L1578.39 480.662L1570.91 469.437C1561.33 474.825 1557.94 471.682 1557.44 469.437L1548.46 462.702L1535.74 476.921L1548.46 486.649H1557.44L1570.91 491.888L1553.7 503.113L1570.91 518.829L1578.39 530.054L1582.88 545.77L1578.39 565.976L1570.91 580.943L1553.7 589.175L1535.74 592.917L1526.01 601.897L1516.28 592.917L1506.55 599.652L1502.06 611.626L1516.28 628.838L1526.01 645.302V664.011L1516.28 672.243L1509.54 681.224H1502.06V672.243L1489.34 664.011L1474.37 654.283H1469.13V664.011L1461.65 654.283L1455.66 637.07L1449.67 628.838L1442.19 633.328H1434.71V623.6L1429.47 611.626L1417.5 601.897Z",
    stroke: "#FFEC3F",
    strokeOpacity: 0.9,
    strokeWidth: 3,
    strokeDasharray: "2 2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1629.28 524.067L1625.54 513.59L1627.79 506.855L1634.52 500.12H1643.5L1653.98 493.385L1664.46 481.411L1659.97 471.682L1651.73 455.966V446.238V435.012L1661.46 441.747L1674.93 446.238L1671.19 453.721H1661.46V464.947H1668.2L1674.93 475.424V483.656L1677.93 493.385V505.358H1664.46L1656.22 513.59L1647.24 512.094H1640.51L1634.52 509.1L1630.78 512.094L1636.77 518.829L1634.52 527.809L1629.28 524.067Z",
    stroke: "#FFC700",
    strokeWidth: 3,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_f_4841_17758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1629.28 524.067L1625.54 513.59L1627.79 506.855L1634.52 500.12H1643.5L1653.98 493.385L1664.46 481.411L1659.97 471.682L1651.73 455.966V446.238V435.012L1661.46 441.747L1674.93 446.238L1671.19 453.721H1661.46V464.947H1668.2L1674.93 475.424V483.656L1677.93 493.385V505.358H1664.46L1656.22 513.59L1647.24 512.094H1640.51L1634.52 509.1L1630.78 512.094L1636.77 518.829L1634.52 527.809L1629.28 524.067Z",
    stroke: "#FFEC3F",
    strokeOpacity: 0.9,
    strokeWidth: 3,
    strokeDasharray: "2 2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1159.31 496.378L1141.35 484.404V466.443L1122.64 447.734V437.257L1141.35 420.045L1155.57 431.27L1149.58 437.257H1141.35V447.734L1155.57 454.47H1165.3L1170.54 462.702L1159.31 466.443L1165.3 476.921L1170.54 488.146L1159.31 496.378Z",
    stroke: "#FFC700",
    strokeWidth: 3,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_f_4841_17758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1159.31 496.378L1141.35 484.404V466.443L1122.64 447.734V437.257L1141.35 420.045L1155.57 431.27L1149.58 437.257H1141.35V447.734L1155.57 454.47H1165.3L1170.54 462.702L1159.31 466.443L1165.3 476.921L1170.54 488.146L1159.31 496.378Z",
    stroke: "#FFEC3F",
    strokeOpacity: 0.9,
    strokeWidth: 3,
    strokeDasharray: "2 2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1043.32 458.96L1026.1 464.947L1015.63 449.98L1020.12 436.509L1035.08 424.535L1043.32 436.509H1055.29V424.535H1069.51V436.509L1082.23 444.741L1094.21 458.96L1082.23 464.947L1063.52 458.96H1043.32Z",
    stroke: "#FFC700",
    strokeWidth: 3,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_f_4841_17758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1043.32 458.96L1026.1 464.947L1015.63 449.98L1020.12 436.509L1035.08 424.535L1043.32 436.509H1055.29V424.535H1069.51V436.509L1082.23 444.741L1094.21 458.96L1082.23 464.947L1063.52 458.96H1043.32Z",
    stroke: "#FFEC3F",
    strokeOpacity: 0.9,
    strokeWidth: 3,
    strokeDasharray: "2 2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M852.485 366.911L865.207 385.62L870.446 390.11L865.207 396.845L847.246 402.084H833.027L837.518 390.11V385.62L847.246 375.143L837.518 366.911V360.176V352.692H847.246L852.485 366.911Z",
    stroke: "#FFC700",
    strokeWidth: 3,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_f_4841_17758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M852.485 366.911L865.207 385.62L870.446 390.11L865.207 396.845L847.246 402.084H833.027L837.518 390.11V385.62L847.246 375.143L837.518 366.911V360.176V352.692H847.246L852.485 366.911Z",
    stroke: "#FFEC3F",
    strokeOpacity: 0.9,
    strokeWidth: 3,
    strokeDasharray: "2 2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M811.324 377.388L823.298 372.15C832.877 367.959 830.782 373.896 828.537 377.388L823.298 388.614L811.324 394.601V377.388Z",
    stroke: "#FFC700",
    strokeWidth: 3,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_f_4841_17758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M811.324 377.388L823.298 372.15C832.877 367.959 830.782 373.896 828.537 377.388L823.298 388.614L811.324 394.601V377.388Z",
    stroke: "#FFEC3F",
    strokeOpacity: 0.9,
    strokeWidth: 3,
    strokeDasharray: "2 2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M758.938 310.036L775.401 304.797H794.111L802.343 310.036L785.879 319.765H767.918L758.938 310.036Z",
    stroke: "#FFC700",
    strokeWidth: 3,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_f_4841_17758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M758.938 310.036L775.401 304.797H794.111L802.343 310.036L785.879 319.765H767.918L758.938 310.036Z",
    stroke: "#FFEC3F",
    strokeOpacity: 0.9,
    strokeWidth: 3,
    strokeDasharray: "2 2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M621.987 304.049L629.471 292.075C639.649 287.884 639.698 279.353 638.451 275.611L629.471 259.147L613.007 245.676H600.285L587.562 240.438V232.206H613.007L629.471 223.974L652.67 219.484L689.34 223.974L711.791 215.742H755.196H785.879L803.839 223.974L792.614 240.438L785.879 253.16L771.66 259.147L760.434 265.882L771.66 275.611L760.434 281.598L739.48 288.333L724.513 292.075L711.791 297.313L689.34 304.049L668.386 315.274L652.67 336.977H638.451L621.987 325.003V304.049Z",
    stroke: "#FFC700",
    strokeWidth: 3,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_f_4841_17758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M621.987 304.049L629.471 292.075C639.649 287.884 639.698 279.353 638.451 275.611L629.471 259.147L613.007 245.676H600.285L587.562 240.438V232.206H613.007L629.471 223.974L652.67 219.484L689.34 223.974L711.791 215.742H755.196H785.879L803.839 223.974L792.614 240.438L785.879 253.16L771.66 259.147L760.434 265.882L771.66 275.611L760.434 281.598L739.48 288.333L724.513 292.075L711.791 297.313L689.34 304.049L668.386 315.274L652.67 336.977H638.451L621.987 325.003V304.049Z",
    stroke: "#FFEC3F",
    strokeOpacity: 0.9,
    strokeWidth: 3,
    strokeDasharray: "2 2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M541.163 227.716L526.944 240.438L544.905 247.173L559.124 240.438L577.085 234.451L610.013 227.716L631.715 212L592.8 216.49H566.608V227.716H559.124H541.163Z",
    stroke: "#FFC700",
    strokeWidth: 3,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_f_4841_17758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M541.163 227.716L526.944 240.438L544.905 247.173L559.124 240.438L577.085 234.451L610.013 227.716L631.715 212L592.8 216.49H566.608V227.716H559.124H541.163Z",
    stroke: "#FFEC3F",
    strokeOpacity: 0.9,
    strokeWidth: 3,
    strokeDasharray: "2 2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M505.99 260.644H491.023L476.056 268.876L491.023 277.856H505.99H523.203L536.673 294.32V299.558H523.203L514.222 310.036L523.203 321.261L541.163 326.5L552.389 316.022V304.797H558.376C575.139 308.988 574.84 303.051 572.595 299.558L563.614 287.585L552.389 274.114L541.163 268.876H532.183L523.203 264.385L505.99 260.644Z",
    stroke: "#FFC700",
    strokeWidth: 3,
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_f_4841_17758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M505.99 260.644H491.023L476.056 268.876L491.023 277.856H505.99H523.203L536.673 294.32V299.558H523.203L514.222 310.036L523.203 321.261L541.163 326.5L552.389 316.022V304.797H558.376C575.139 308.988 574.84 303.051 572.595 299.558L563.614 287.585L552.389 274.114L541.163 268.876H532.183L523.203 264.385L505.99 260.644Z",
    stroke: "#FFEC3F",
    strokeOpacity: 0.9,
    strokeWidth: 3,
    strokeDasharray: "3 3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M346.59 255.405L335.364 260.644L321.894 265.882L326.384 274.114L335.364 265.882H350.331L356.318 274.114L346.59 286.088H360.06H369.04H381.014L394.485 283.095L410.2 280.85V274.114V265.882H404.962H398.227L391.491 260.644L384.008 265.882L374.279 260.644L360.06 255.405H346.59Z",
    stroke: "#FFC700",
    strokeWidth: 3,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_f_4841_17758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.59 255.405L335.364 260.644L321.894 265.882L326.384 274.114L335.364 265.882H350.331L356.318 274.114L346.59 286.088H360.06H369.04H381.014L394.485 283.095L410.2 280.85V274.114V265.882H404.962H398.227L391.491 260.644L384.008 265.882L374.279 260.644L360.06 255.405H346.59Z",
    stroke: "#FFEC3F",
    strokeOpacity: 0.9,
    strokeWidth: 3,
    strokeDasharray: "2 2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M558.376 405.826L572.595 414.806L558.376 419.297H544.157L537.422 414.806L544.157 409.568L558.376 396.846V405.826Z",
    stroke: "#FFC700",
    strokeWidth: 3,
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_f_4841_17758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M558.376 405.826L572.595 414.806L558.376 419.297H544.157L537.422 414.806L544.157 409.568L558.376 396.846V405.826Z",
    stroke: "#FFEC3F",
    strokeOpacity: 0.9,
    strokeWidth: 3,
    strokeDasharray: "3 3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M413.942 482.159L440.135 461.953L456.599 456.715L467.076 443.992L485.036 434.264H491.772V443.992H502.997L520.209 434.264L502.997 426.78L508.984 411.064H496.262L502.997 399.091H523.951H540.415L556.879 390.859L568.105 380.381L556.879 376.64L548.647 364.666L544.157 339.221L523.951 350.447L516.468 339.221V330.989L491.772 323.506L479.05 330.989L471.566 346.705V357.182L456.599 370.653L443.876 376.64V386.368L432.651 395.349L425.167 386.368L429.658 368.408L413.942 364.666L404.213 357.182L389.246 346.705L398.975 330.989L419.18 323.506L432.651 316.022L449.863 310.784L460.34 304.797L479.05 310.784L474.559 320.512L456.599 316.022L467.076 298.81H485.036L496.262 290.578V282.346H485.036L467.076 290.578L460.34 282.346L456.599 270.372L443.876 275.611V282.346L432.651 290.578V282.346H425.167V290.578H413.942L398.975 294.32L389.246 290.578L371.285 294.32V298.81L351.079 294.32L330.125 282.346H306.178H286.72L256.037 290.578L235.083 282.346L183.446 275.611H161.744L132.557 282.346L122.829 286.836C118.089 286.836 109.508 289.231 113.1 298.81L101.126 304.797H86.1589C84.6621 307.042 83.6144 312.43 91.3974 316.022L80.172 323.506H66.7014L59.9661 335.48L50.2374 339.221L59.9661 346.705L33.7734 368.408L80.172 350.447L105.616 339.221H113.1L137.048 330.989L158.002 339.221L173.717 350.447L181.201 360.176C178.706 369.156 173.717 389.511 173.717 399.091C187.188 399.091 196.168 413.309 188.685 416.303C182.698 418.698 168.229 435.76 161.744 443.992L144.531 467.192L149.77 506.106L161.744 522.57V536.789L166.982 557.744L173.717 573.459L181.201 582.44V557.744L173.717 543.525V532.299H181.201V549.512L193.175 568.221L207.394 590.672V607.884L240.322 628.838H270.256L281.482 642.309L300.939 649.792H308.423L315.158 662.514L328.629 679.727L347.338 689.455L361.556 679.727H347.338L332.37 662.514V634.077H315.158L308.423 628.838L315.158 604.142C317.902 600.151 319.648 593.366 304.681 598.155L294.204 612.374L276.991 618.361L265.018 607.884L256.786 590.672L265.018 562.982L270.256 549.512L294.204 536.789L315.158 543.525L332.37 532.299L343.596 536.789L357.066 543.525V562.982L361.556 568.221L371.285 562.982V549.512L365.298 532.299L379.517 522.57L391.491 512.842L410.2 506.106V489.642L413.942 482.159Z",
    stroke: "#FFC700",
    strokeWidth: 3,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_f_4841_17758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.942 482.159L440.135 461.953L456.599 456.715L467.076 443.992L485.036 434.264H491.772V443.992H502.997L520.209 434.264L502.997 426.78L508.984 411.064H496.262L502.997 399.091H523.951H540.415L556.879 390.859L568.105 380.381L556.879 376.64L548.647 364.666L544.157 339.221L523.951 350.447L516.468 339.221V330.989L491.772 323.506L479.05 330.989L471.566 346.705V357.182L456.599 370.653L443.876 376.64V386.368L432.651 395.349L425.167 386.368L429.658 368.408L413.942 364.666L404.213 357.182L389.246 346.705L398.975 330.989L419.18 323.506L432.651 316.022L449.863 310.784L460.34 304.797L479.05 310.784L474.559 320.512L456.599 316.022L467.076 298.81H485.036L496.262 290.578V282.346H485.036L467.076 290.578L460.34 282.346L456.599 270.372L443.876 275.611V282.346L432.651 290.578V282.346H425.167V290.578H413.942L398.975 294.32L389.246 290.578L371.285 294.32V298.81L351.079 294.32L330.125 282.346H306.178H286.72L256.037 290.578L235.083 282.346L183.446 275.611H161.744L132.557 282.346L122.829 286.836C118.089 286.836 109.508 289.231 113.1 298.81L101.126 304.797H86.1589C84.6621 307.042 83.6144 312.43 91.3974 316.022L80.172 323.506H66.7014L59.9661 335.48L50.2374 339.221L59.9661 346.705L33.7734 368.408L80.172 350.447L105.616 339.221H113.1L137.048 330.989L158.002 339.221L173.717 350.447L181.201 360.176C178.706 369.156 173.717 389.511 173.717 399.091C187.188 399.091 196.168 413.309 188.685 416.303C182.698 418.698 168.229 435.76 161.744 443.992L144.531 467.192L149.77 506.106L161.744 522.57V536.789L166.982 557.744L173.717 573.459L181.201 582.44V557.744L173.717 543.525V532.299H181.201V549.512L193.175 568.221L207.394 590.672V607.884L240.322 628.838H270.256L281.482 642.309L300.939 649.792H308.423L315.158 662.514L328.629 679.727L347.338 689.455L361.556 679.727H347.338L332.37 662.514V634.077H315.158L308.423 628.838L315.158 604.142C317.902 600.151 319.648 593.366 304.681 598.155L294.204 612.374L276.991 618.361L265.018 607.884L256.786 590.672L265.018 562.982L270.256 549.512L294.204 536.789L315.158 543.525L332.37 532.299L343.596 536.789L357.066 543.525V562.982L361.556 568.221L371.285 562.982V549.512L365.298 532.299L379.517 522.57L391.491 512.842L410.2 506.106V489.642L413.942 482.159Z",
    stroke: "#FFEC3F",
    strokeOpacity: 0.9,
    strokeWidth: 3,
    strokeDasharray: "2 2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M419.18 617.613H398.226L404.212 605.639H411.696L432.65 610.129L419.18 617.613Z",
    stroke: "#FFC700",
    strokeWidth: 3,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_f_4841_17758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419.18 617.613H398.226L404.212 605.639H411.696L432.65 610.129L419.18 617.613Z",
    stroke: "#FFEC3F",
    strokeOpacity: 0.9,
    strokeWidth: 3,
    strokeDasharray: "2 2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M367.543 583.937H342.847L349.582 589.175L362.304 595.91L373.53 604.142L396.729 600.401L389.245 595.91L367.543 583.937Z",
    stroke: "#FFC700",
    strokeWidth: 3,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter27_f_4841_17758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.543 583.937H342.847L349.582 589.175L362.304 595.91L373.53 604.142L396.729 600.401L389.245 595.91L367.543 583.937Z",
    stroke: "#FFEC3F",
    strokeOpacity: 0.9,
    strokeWidth: 3,
    strokeDasharray: "2 2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M357.066 426.78H378.021L364.55 438.006L357.066 454.47L360.808 461.205L369.789 454.47L378.021 434.264H391.491V446.238L407.207 438.006V426.78H398.975L391.491 422.29L384.007 414.058H364.55L357.066 426.78Z",
    stroke: "#FFC700",
    strokeWidth: 3,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter28_f_4841_17758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.066 426.78H378.021L364.55 438.006L357.066 454.47L360.808 461.205L369.789 454.47L378.021 434.264H391.491V446.238L407.207 438.006V426.78H398.975L391.491 422.29L384.007 414.058H364.55L357.066 426.78Z",
    stroke: "#FFEC3F",
    strokeOpacity: 0.9,
    strokeWidth: 3,
    strokeDasharray: "2 2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M488.03 250.166L524.7 256.902L532.932 250.166H511.23L497.759 243.431L488.03 250.166Z",
    stroke: "#FFC700",
    strokeWidth: 3,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter29_f_4841_17758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M488.03 250.166L524.7 256.902L532.932 250.166H511.23L497.759 243.431L488.03 250.166Z",
    stroke: "#FFEC3F",
    strokeOpacity: 0.9,
    strokeWidth: 3,
    strokeDasharray: "2 2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M528.442 220.98L523.203 231.457H512.726L502.249 227.715L512.726 220.98H528.442Z",
    stroke: "#FFC700",
    strokeWidth: 3,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter30_f_4841_17758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M528.442 220.98L523.203 231.457H512.726L502.249 227.715L512.726 220.98H528.442Z",
    stroke: "#FFEC3F",
    strokeOpacity: 0.9,
    strokeWidth: 3,
    strokeDasharray: "2 2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M941.539 367.659L948.274 354.937L952.765 345.957L956.506 339.221L948.274 330.241V322.009L963.99 316.77L973.719 301.803L984.196 310.035L969.977 322.009L973.719 335.48H999.163L1008.89 339.221L999.163 345.957H984.196V354.937H973.719V367.659L963.99 374.394H956.506L941.539 379.633L934.055 374.394H918.34L928.069 367.659H941.539Z",
    stroke: "#FFC700",
    strokeWidth: 3,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter31_f_4841_17758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M941.539 367.659L948.274 354.937L952.765 345.957L956.506 339.221L948.274 330.241V322.009L963.99 316.77L973.719 301.803L984.196 310.035L969.977 322.009L973.719 335.48H999.163L1008.89 339.221L999.163 345.957H984.196V354.937H973.719V367.659L963.99 374.394H956.506L941.539 379.633L934.055 374.394H918.34L928.069 367.659H941.539Z",
    stroke: "#FFEC3F",
    strokeOpacity: 0.9,
    strokeWidth: 3,
    strokeDasharray: "2 2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1591.87 762.047L1598.6 744.834C1595.01 739.446 1600.1 734.108 1603.09 732.112C1603.09 728.52 1622.55 730.616 1632.28 732.112C1632.28 744.086 1618.31 740.095 1611.32 736.602L1606.08 741.841L1608.33 749.325H1619.55L1611.32 756.06L1615.81 766.537L1611.32 771.776L1606.08 762.047L1603.09 766.537V780.008L1591.87 777.762V762.047Z",
    stroke: "#FFC700",
    strokeWidth: 3,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter32_f_4841_17758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1591.87 762.047L1598.6 744.834C1595.01 739.446 1600.1 734.108 1603.09 732.112C1603.09 728.52 1622.55 730.616 1632.28 732.112C1632.28 744.086 1618.31 740.095 1611.32 736.602L1606.08 741.841L1608.33 749.325H1619.55L1611.32 756.06L1615.81 766.537L1611.32 771.776L1606.08 762.047L1603.09 766.537V780.008L1591.87 777.762V762.047Z",
    stroke: "#FFEC3F",
    strokeOpacity: 0.9,
    strokeWidth: 3,
    strokeDasharray: "2 2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4841_17758",
    x: 713.186,
    y: 452.702,
    width: 486.363,
    height: 557.161,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_4841_17758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4841_17758",
    x: 1083.16,
    y: 789.046,
    width: 110.404,
    height: 156.921,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_4841_17758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_4841_17758",
    x: 1647.12,
    y: 985.984,
    width: 91.082,
    height: 84.4282,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_4841_17758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_4841_17758",
    x: 1504.48,
    y: 782.783,
    width: 307.225,
    height: 257.689,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_4841_17758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_4841_17758",
    x: 1754.44,
    y: 982.395,
    width: 125.373,
    height: 108.007,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_4841_17758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_4841_17758",
    x: 1823.4,
    y: 946.932,
    width: 98.1738,
    height: 109.046,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_4841_17758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_4841_17758",
    x: 315.037,
    y: 624.524,
    width: 351.676,
    height: 522.081,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_4841_17758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_4841_17758",
    x: 1634.32,
    y: 713.58,
    width: 189.256,
    height: 138.398,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_4841_17758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_4841_17758",
    x: 1497.58,
    y: 665.684,
    width: 127.938,
    height: 135.85,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_4841_17758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_4841_17758",
    x: 1476.11,
    y: 752.495,
    width: 125.348,
    height: 81.3252,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_4841_17758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_4841_17758",
    x: 1413.93,
    y: 669.409,
    width: 130.611,
    height: 145.34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_4841_17758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_4841_17758",
    x: 1558.26,
    y: 583.81,
    width: 114.248,
    height: 151.868,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_4841_17758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_4841_17758",
    x: 1429.9,
    y: 624.069,
    width: 102.418,
    height: 139.046,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_4841_17758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_4841_17758",
    x: 771.707,
    y: 206.189,
    width: 1018.75,
    height: 510.805,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_4841_17758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_4841_17758",
    x: 1591.96,
    y: 400.149,
    width: 119.471,
    height: 162.161,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_4841_17758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_f_4841_17758",
    x: 1089.14,
    y: 386.075,
    width: 115.691,
    height: 144.133,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_4841_17758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_f_4841_17758",
    x: 981.965,
    y: 390.356,
    width: 146.613,
    height: 108.38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_4841_17758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_f_4841_17758",
    x: 798.863,
    y: 319.192,
    width: 105.645,
    height: 116.392,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_4841_17758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_f_4841_17758",
    x: 777.824,
    y: 337.208,
    width: 86.1094,
    height: 91.8193,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_4841_17758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_f_4841_17758",
    x: 724.236,
    y: 271.297,
    width: 112.975,
    height: 81.9673,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_4841_17758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_f_4841_17758",
    x: 554.062,
    y: 182.242,
    width: 284.018,
    height: 188.235,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_4841_17758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_f_4841_17758",
    x: 492.098,
    y: 177.853,
    width: 177.141,
    height: 102.948,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_4841_17758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_f_4841_17758",
    x: 441.046,
    y: 227.144,
    width: 165.729,
    height: 133.035,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_4841_17758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_f_4841_17758",
    x: 287.76,
    y: 221.905,
    width: 155.94,
    height: 97.6831,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_4841_17758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_f_4841_17758",
    x: 502.858,
    y: 361.491,
    width: 105.271,
    height: 91.3057,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_4841_17758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_f_4841_17758",
    x: 0.816406,
    y: 236.361,
    width: 602.156,
    height: 486.839,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_4841_17758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_f_4841_17758",
    x: 363.799,
    y: 572.139,
    width: 105.073,
    height: 78.9736,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_4841_17758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_f_4841_17758",
    x: 306.475,
    y: 550.437,
    width: 126.548,
    height: 87.2866,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_4841_17758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_f_4841_17758",
    x: 322.443,
    y: 380.558,
    width: 118.264,
    height: 114.879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_4841_17758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_f_4841_17758",
    x: 452.207,
    y: 209.692,
    width: 116.927,
    height: 80.8101,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_4841_17758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_f_4841_17758",
    x: 466.873,
    y: 187.48,
    width: 95.9961,
    height: 77.4771,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_4841_17758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_f_4841_17758",
    x: 881.537,
    y: 267.61,
    width: 162.541,
    height: 145.693,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_4841_17758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter32_f_4841_17758",
    x: 1558.37,
    y: 696.629,
    width: 107.412,
    height: 117.208,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_4841_17758"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4841_17758"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1919,
    height: 1133.06,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/Map.82a3e30fa04d4ca56d6468599bf5acd6.svg";
export { ForwardRef as ReactComponent };